<template>
  <div class="container" v-if="reservation">
    <h1>Detalles de la Reservación</h1>
    <p><strong>Nombre:</strong> {{ reservation.name }}</p>
    <p><strong>Fecha:</strong> {{ reservation.date }}</p>
    <p><strong>Hora:</strong> {{ formatTime(reservation.time) }}</p>
    <p><strong>Personas:</strong> {{ reservation.people }}</p>
    <p v-if="reservation.tableNumber"><strong>Mesa Asignada:</strong> {{ reservation.tableNumber }}</p>
    <p v-if="reservation.specialNotes"><strong>Notas Especiales:</strong> {{ reservation.specialNotes }}</p>
    <p v-if="reservation.status === 'used'" class="invalid">Esta reservación ya ha sido usada.</p>
  </div>
</template>

<script>
export default {
  props: ['reservation'],
  methods: {
    formatTime(time) {
      const [hour, minute] = time.split(':');
      const date = new Date();
      date.setHours(hour, minute);
      const options = { hour: '2-digit', minute: '2-digit', hour12: true };
      return new Intl.DateTimeFormat('es-ES', options).format(date);
    },
  },
};
</script>

<style scoped>
.invalid {
  color: red;
  font-weight: bold;
  margin-top: 20px;
}
</style>
